"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyPollAppealCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const cards_1 = require("../../../_shared/cards");
const commands_1 = require("../../../_shared/commands");
const components_1 = require("../../../_shared/components");
const CardHelper_1 = require("../../../_shared/utils/CardHelper");
const actions_1 = require("../../actions");
const surveyHelpers_1 = require("../../utils/surveyHelpers");
const SurveyLimits_1 = require("../../utils/SurveyLimits");
function SurveyPollAppealCard(survey, options) {
    const card = CardHelper_1.CardHelper.newCard();
    if (!(options === null || options === void 0 ? void 0 : options.hideDetailsBar)) {
        const isMeetingRecipient = survey.recipients.some(recipient => recipient.type === "meeting");
        const detailsBarOptions = isMeetingRecipient
            ? {
                showStatus: false,
                showCloseDate: false,
                detailsJoinString: " \n\n ",
                hideOwner: true,
            }
            : {
                hideOwner: true,
            };
        card.addItem((0, components_1.detailsBar)(survey, detailsBarOptions));
    }
    if ((options === null || options === void 0 ? void 0 : options.isEdited) || (options === null || options === void 0 ? void 0 : options.reOpened)) {
        card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            weight: adaptivecards_1.TextWeight.Bolder,
            color: adaptivecards_1.TextColor.Good,
            wrap: true,
            text: options.isEdited
                ? (0, surveyHelpers_1.getSurveyEditText)(options.votesInvalidated)
                : (0, surveyHelpers_1.getSurveyReOpenedText)(),
        }));
    }
    if (options === null || options === void 0 ? void 0 : options.hideManagementControls) {
        card.addItem((0, components_1.AppealTitle)(survey));
    }
    else {
        card.addItem((0, components_1.AppealTitleWithManagementMenu)(survey));
    }
    if ((options === null || options === void 0 ? void 0 : options.recipientType) && (options === null || options === void 0 ? void 0 : options.recipientName)) {
        const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container);
        card.addItem(container);
        container.addItem((0, cards_1.getChannelRow)(survey.applicationType, options === null || options === void 0 ? void 0 : options.recipientType, options === null || options === void 0 ? void 0 : options.recipientName));
    }
    if (survey.state === "open") {
        const question = survey.questions[0];
        let canAddChoices = false;
        let canSubmitResponse = true;
        if (question.questionType === "nominal") {
            const nominal = question;
            canAddChoices = nominal.allowUserAddOptions;
            canSubmitResponse = nominal.choices.length > 0;
        }
        if (canSubmitResponse) {
            //dont allow comments on the question for appeals, use the "add comment" button instead
            if (question.allowComments) {
                question.allowComments = false;
                survey.commentsEnabled = true;
                survey.commentsAppeal = question.commentAppeal || survey.commentsAppeal;
            }
            const questionElement = (0, components_1.getQuestionElement)(question, undefined, undefined);
            if (question.questionType !== "open-ended") {
                const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
                    style: adaptivecards_1.ContainerStyle.Emphasis,
                });
                container.addItem(questionElement);
                card.addItem(container);
            }
            else {
                card.addItem(questionElement);
            }
            if (options === null || options === void 0 ? void 0 : options.response) {
                card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
                    text: getResponseText(question, options.response),
                    horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
                    weight: adaptivecards_1.TextWeight.Bolder,
                }));
            }
            const subAction = CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
                title: getSubmitLabel(question.questionType, !!(options === null || options === void 0 ? void 0 : options.response)),
                data: (0, commands_1.takingSubmitCommand)(survey.id, question.id, [question.id]).toInvokeCommand(),
            });
            card.addAction(subAction);
        }
        else {
            const startedContainer = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
                style: adaptivecards_1.ContainerStyle.Emphasis,
            });
            startedContainer.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
                text: "Add a new choice to get started!",
                color: adaptivecards_1.TextColor.Accent,
                size: adaptivecards_1.TextSize.Medium,
                horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
            }));
            card.addItem(startedContainer);
        }
        if (canAddChoices) {
            const addChoiceCard = CardHelper_1.CardHelper.newCard();
            addChoiceCard.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextInput, {
                placeholder: "Add a new choice",
                id: "choice",
                maxLength: SurveyLimits_1.SurveyLimits.Questions.Choices.Value.MaxLength,
            }));
            addChoiceCard.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
                title: "Add choice",
                isPrimary: true,
                data: (0, commands_1.takingQuestionAddChoiceCommand)(survey.id, question.id).toInvokeCommand(),
            }));
            card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.ShowCardAction, {
                // NOTE: if this text is changed, make sure to change the text in Polly preview as well.
                title: "+ Add choice",
                card: addChoiceCard,
            }));
        }
        if (survey.commentsEnabled) {
            card.addAction((0, actions_1.AddCommentAction)(survey));
        }
    }
    if (survey.state === "closed" || survey.deliveryResultLimit === "owners") {
        card.addAction((0, actions_1.ViewSurveyResultsAction)(survey.id));
    }
    return card;
}
exports.SurveyPollAppealCard = SurveyPollAppealCard;
const getSubmitLabel = (questionType, indicateVoteReceived) => {
    if (questionType === "open-ended") {
        // NOTE: if this text is changed, make sure to change the text in Polly preview as well.
        const SubmitResponseButtonLabel = "Submit response";
        return indicateVoteReceived ? "Update response" : SubmitResponseButtonLabel;
    }
    // NOTE: if this text is changed, make sure to change the text in Polly preview as well.
    const submitVoteButtonLabel = "Submit vote";
    return indicateVoteReceived ? "Update vote" : submitVoteButtonLabel;
};
const getResponseText = (question, response) => {
    if (question.questionType === "open-ended") {
        return "✓ Vote received!";
    }
    const questionResponse = response.responses[0];
    const choiceQuestion = question;
    let responseChoice;
    if (questionResponse) {
        for (const choice of choiceQuestion.choices) {
            if (choice.id === questionResponse.value) {
                responseChoice = choice;
            }
        }
    }
    if (!responseChoice) {
        return "✓ Vote received!";
    }
    const responseText = "label" in responseChoice ? responseChoice.label : responseChoice.value;
    return `✓ You responded: ${responseText}`;
};
//# sourceMappingURL=SurveyPollAppealCard.js.map